import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _Getters;

import * as types from "@/store/constants/types";
var Getters = (_Getters = {}, _defineProperty(_Getters, types.GETTER_HOROSCOPE_TIME, function (state, payLoad) {
  return state.horoScopeTime;
}), _defineProperty(_Getters, types.GETTER_HOROSCOPE, function (state, payLoad) {
  return state.horoscope;
}), _defineProperty(_Getters, types.GETTER_TODAY_HOROSCOPE_FATE, function (state, payLoad) {
  return state.todayHoroscopeFate;
}), _defineProperty(_Getters, types.GETTER_TOMORROW_HOROSCOPE_FATE, function (state, payLoad) {
  return state.tomorrowHoroscopeFate;
}), _defineProperty(_Getters, types.GETTER_WEEK_HOROSCOPE_FATE, function (state, payLoad) {
  return state.weekHoroscopeFate;
}), _defineProperty(_Getters, types.GETTER_MONTH_HOROSCOPE_FATE, function (state, payLoad) {
  return state.monthHoroscopeFate;
}), _defineProperty(_Getters, types.GETTER_YEAR_HOROSCOPE_FATE, function (state, payLoad) {
  return state.yearHoroscopeFate;
}), _defineProperty(_Getters, types.GETTER_DAILY_PLAMISTRY_DATA, function (state, payLoad) {
  return state.dailyPlamistryData;
}), _Getters);
export default Getters;